import { lazy } from 'react';

export const Topic = lazy(() => import('./Topic.component'));
